import { Injectable } from '@angular/core';
import { FormService } from './form.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FieldConfig } from '../models/form-field.model';
import { FormDateRangeField } from '../components/form-date-range/form-date-range.model';

@Injectable()
export class FormFieldService {

  constructor(
    private formService: FormService,
    private fb: FormBuilder
  ) { }

  addControl(group: FormGroup, field: FieldConfig) {
    if (['button', 'fileUpload', 'label'].includes(field.type)) { return; }
    if (!field.name) { return; }
    const control = group.get(field.name);
    if (control) {
      return;
    }

    const newControl = this.fb.control(null, this.bindValidations(field.validations || []));
    group.addControl(field.name, newControl);

    if (field.type === 'daterange') {
      this.addControl(group, (field as FormDateRangeField<any>).field2);
    }
  }

  private bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      validations.forEach(valid => {
        validList.push(valid.validator);
      });
      return Validators.compose(validList);
    }
    return null;
  }

  removeControl(group: FormGroup, field: FieldConfig) {
    if (!group) {
      return;
    }
    const control = group.get(field.name);
    if (control) {
      group.removeControl(field.name);
    }

    if (field.type === 'daterange') {
      const control2 = group.get((field as FormDateRangeField<any>).field2.name);
      if (control2) {
        group.removeControl((field as FormDateRangeField<any>).field2.name);
      }
    }
  }

}
